export * from '@mui/icons-material';

const PriorityFlagBlue = '/icons/priority_flags/flag-blue.png';
const PriorityFlagGrey = '/icons/priority_flags/flag-grey.png';
const PriorityFlagOrange = '/icons/priority_flags/flag-orange.png';
const PriorityFlagRed = '/icons/priority_flags/flag-red.png';

const CalendarToday = '/icons/calendar/today.png';
const CalendarTomorrow = '/icons/calendar/tomorrow.png';
const CalendarWeekend = '/icons/calendar/weekend.png';
const CalendarNextWeek = '/icons/calendar/next_week.png';

export {
  PriorityFlagBlue,
  PriorityFlagGrey,
  PriorityFlagOrange,
  PriorityFlagRed,

  CalendarToday,
  CalendarTomorrow,
  CalendarWeekend,
  CalendarNextWeek,
};
